/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './dropdown-demo.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../shared/panel/panel.component.ngfactory';
import * as i3 from '../../../../../src/app/shared/panel/panel.component';
import * as i4 from '../../shared/dropdown/dropdown.component.ngfactory';
import * as i5 from '../../../../../src/app/shared/dropdown/dropdown.component';
import * as i6 from '../../shared/grid/grid.component.ngfactory';
import * as i7 from '../../../../../src/app/shared/grid/grid.component';
import * as i8 from '../../../../../src/app/ui-element/dropdown/dropdown-demo.component';
const styles_DropdownDemoComponent:any[] = [i0.styles];
export const RenderType_DropdownDemoComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_DropdownDemoComponent,data:{}});
function View_DropdownDemoComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),24,'admin-panel',
      [['class','panel--basic'],['headerColor','rgb(85,201,166)']],[[2,'tabbed',(null as any)],
          [2,'minimized',(null as any)],[2,'closed',(null as any)]],(null as any),
      (null as any),i2.View_PanelComponent_0,i2.RenderType_PanelComponent)),i1.ɵdid(4767744,
      (null as any),0,i3.PanelComponent,([] as any[]),{showHeader:[0,'showHeader'],
          headerColor:[1,'headerColor']},(null as any)),(_l()(),i1.ɵeld(0,(null as any),
      0,2,'header',([] as any[]),(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'h3',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted((null as any),['Dropdowns and dropups'])),(_l()(),i1.ɵeld(0,(null as any),
      1,4,'div',[['class','dropdown-container']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),
      1,'admin-dropdown',[['color','green'],['text','basic']],(null as any),[[(null as any),
          'mouseenter'],[(null as any),'mouseleave']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('mouseenter' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,7).onHover()) !== false);
          ad = (pd_0 && ad);
        }
        if (('mouseleave' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,7).onLeave()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
      (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
          'options'],color:[2,'color']},(null as any)),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),1,'admin-dropdown',[['color','green'],['text','outlined']],(null as any),
      [[(null as any),'mouseenter'],[(null as any),'mouseleave']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('mouseenter' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,9).onHover()) !== false);
          ad = (pd_0 && ad);
        }
        if (('mouseleave' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,9).onLeave()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
      (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
          'options'],color:[2,'color'],outlined:[3,'outlined']},(null as any)),(_l()(),
      i1.ɵeld(0,(null as any),1,4,'div',[['class','dropdown-container']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵeld(0,
      (null as any),(null as any),1,'admin-dropdown',[['color','blue'],['text','with headers']],
      (null as any),[[(null as any),'mouseenter'],[(null as any),'mouseleave']],(_v,
          en,$event) => {
        var ad:boolean = true;
        if (('mouseenter' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,12).onHover()) !== false);
          ad = (pd_0 && ad);
        }
        if (('mouseleave' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,12).onLeave()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
      (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
          'options'],color:[2,'color']},(null as any)),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),1,'admin-dropdown',[['color','darkblue'],['text','disabled']],
      (null as any),[[(null as any),'mouseenter'],[(null as any),'mouseleave']],(_v,
          en,$event) => {
        var ad:boolean = true;
        if (('mouseenter' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,14).onHover()) !== false);
          ad = (pd_0 && ad);
        }
        if (('mouseleave' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,14).onLeave()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
      (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
          'options'],color:[2,'color'],outlined:[3,'outlined'],disabled:[4,'disabled']},
      (null as any)),(_l()(),i1.ɵeld(0,(null as any),1,4,'div',[['class','dropdown-container']],
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵeld(0,(null as any),(null as any),1,'admin-dropdown',[['color','green'],
          ['text','basic']],(null as any),[[(null as any),'mouseenter'],[(null as any),
          'mouseleave']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('mouseenter' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,17).onHover()) !== false);
          ad = (pd_0 && ad);
        }
        if (('mouseleave' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,17).onLeave()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
      (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
          'options'],color:[2,'color'],dropup:[3,'dropup']},(null as any)),(_l()(),
      i1.ɵeld(0,(null as any),(null as any),1,'admin-dropdown',[['color','green'],
          ['text','outlined']],(null as any),[[(null as any),'mouseenter'],[(null as any),
          'mouseleave']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('mouseenter' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,19).onHover()) !== false);
          ad = (pd_0 && ad);
        }
        if (('mouseleave' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,19).onLeave()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
      (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
          'options'],color:[2,'color'],outlined:[3,'outlined'],dropup:[4,'dropup']},
      (null as any)),(_l()(),i1.ɵeld(0,(null as any),1,4,'div',[['class','dropdown-container']],
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵeld(0,(null as any),(null as any),1,'admin-dropdown',[['color','blue'],['text',
          'with headers']],(null as any),[[(null as any),'mouseenter'],[(null as any),
          'mouseleave']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('mouseenter' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,22).onHover()) !== false);
          ad = (pd_0 && ad);
        }
        if (('mouseleave' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,22).onLeave()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
      (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
          'options'],color:[2,'color'],dropup:[3,'dropup']},(null as any)),(_l()(),
      i1.ɵeld(0,(null as any),(null as any),1,'admin-dropdown',[['color','darkblue'],
          ['text','disabled']],(null as any),[[(null as any),'mouseenter'],[(null as any),
          'mouseleave']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('mouseenter' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,24).onHover()) !== false);
          ad = (pd_0 && ad);
        }
        if (('mouseleave' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,24).onLeave()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
      (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
          'options'],color:[2,'color'],outlined:[3,'outlined'],dropup:[4,'dropup'],
          disabled:[5,'disabled']},(null as any)),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),24,'admin-panel',[['class','panel--basic-inverse'],['headerColor',
          'rgb(85,201,166)']],[[2,'tabbed',(null as any)],[2,'minimized',(null as any)],
          [2,'closed',(null as any)]],(null as any),(null as any),i2.View_PanelComponent_0,
      i2.RenderType_PanelComponent)),i1.ɵdid(4767744,(null as any),0,i3.PanelComponent,
      ([] as any[]),{showHeader:[0,'showHeader'],showBody:[1,'showBody'],headerColor:[2,
          'headerColor']},(null as any)),(_l()(),i1.ɵeld(0,(null as any),0,22,'header',
      ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),1,'h3',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['Dropdowns and dropups (inverse)'])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          4,'div',[['class','dropdown-container']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          1,'admin-dropdown',[['color','darkblue'],['text','basic']],(null as any),
          [[(null as any),'mouseenter'],[(null as any),'mouseleave']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('mouseenter' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,32).onHover()) !== false);
              ad = (pd_0 && ad);
            }
            if (('mouseleave' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,32).onLeave()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],inverse:[3,'inverse']},(null as any)),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),1,'admin-dropdown',[['color','darkblue'],
              ['text','outlined']],(null as any),[[(null as any),'mouseenter'],[(null as any),
              'mouseleave']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('mouseenter' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,34).onHover()) !== false);
              ad = (pd_0 && ad);
            }
            if (('mouseleave' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,34).onLeave()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],inverse:[3,'inverse']},(null as any)),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),4,'div',[['class','dropdown-container']],
              (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-dropdown',[['color','darkblue'],
          ['text','with headers']],(null as any),[[(null as any),'mouseenter'],[(null as any),
          'mouseleave']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('mouseenter' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,37).onHover()) !== false);
          ad = (pd_0 && ad);
        }
        if (('mouseleave' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,37).onLeave()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],inverse:[3,'inverse']},(null as any)),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),1,'admin-dropdown',[['color','darkblue'],
              ['text','disabled']],(null as any),[[(null as any),'mouseenter'],[(null as any),
              'mouseleave']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('mouseenter' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,39).onHover()) !== false);
              ad = (pd_0 && ad);
            }
            if (('mouseleave' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,39).onLeave()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],inverse:[3,'inverse'],disabled:[4,'disabled']},
          (null as any)),(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'div',[['class',
          'dropdown-container']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-dropdown',
          [['color','darkblue'],['text','basic']],(null as any),[[(null as any),'mouseenter'],
              [(null as any),'mouseleave']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('mouseenter' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,42).onHover()) !== false);
              ad = (pd_0 && ad);
            }
            if (('mouseleave' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,42).onLeave()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],inverse:[3,'inverse'],dropup:[4,'dropup']},
          (null as any)),(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-dropdown',
          [['color','darkblue'],['text','outlined']],(null as any),[[(null as any),
              'mouseenter'],[(null as any),'mouseleave']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('mouseenter' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,44).onHover()) !== false);
              ad = (pd_0 && ad);
            }
            if (('mouseleave' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,44).onLeave()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],inverse:[3,'inverse'],dropup:[4,'dropup']},
          (null as any)),(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'div',[['class',
          'dropdown-container']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-dropdown',
          [['color','darkblue'],['text','with headers']],(null as any),[[(null as any),
              'mouseenter'],[(null as any),'mouseleave']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('mouseenter' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,47).onHover()) !== false);
              ad = (pd_0 && ad);
            }
            if (('mouseleave' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,47).onLeave()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],inverse:[3,'inverse'],dropup:[4,'dropup']},
          (null as any)),(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-dropdown',
          [['color','darkblue'],['text','disabled']],(null as any),[[(null as any),
              'mouseenter'],[(null as any),'mouseleave']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('mouseenter' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,49).onHover()) !== false);
              ad = (pd_0 && ad);
            }
            if (('mouseleave' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,49).onLeave()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],inverse:[3,'inverse'],dropup:[4,'dropup'],
              disabled:[5,'disabled']},(null as any)),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),24,'admin-panel',[['class','panel--basic-hover'],['headerColor',
              'rgb(168,85,58)']],[[2,'tabbed',(null as any)],[2,'minimized',(null as any)],
              [2,'closed',(null as any)]],(null as any),(null as any),i2.View_PanelComponent_0,
          i2.RenderType_PanelComponent)),i1.ɵdid(4767744,(null as any),0,i3.PanelComponent,
          ([] as any[]),{showHeader:[0,'showHeader'],headerColor:[1,'headerColor']},
          (null as any)),(_l()(),i1.ɵeld(0,(null as any),0,2,'header',([] as any[]),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),1,'h3',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['Dropdowns and dropups (hover buttons)'])),(_l()(),i1.ɵeld(0,(null as any),
          1,4,'div',[['class','dropdown-container']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          1,'admin-dropdown',[['color','brown'],['text','basic']],(null as any),[[(null as any),
              'mouseenter'],[(null as any),'mouseleave']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('mouseenter' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,57).onHover()) !== false);
              ad = (pd_0 && ad);
            }
            if (('mouseleave' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,57).onLeave()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],hover:[3,'hover']},(null as any)),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),1,'admin-dropdown',[['color','brown'],
              ['text','outlined']],(null as any),[[(null as any),'mouseenter'],[(null as any),
              'mouseleave']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('mouseenter' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,59).onHover()) !== false);
              ad = (pd_0 && ad);
            }
            if (('mouseleave' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,59).onLeave()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],outlined:[3,'outlined'],hover:[4,'hover']},
          (null as any)),(_l()(),i1.ɵeld(0,(null as any),1,4,'div',[['class','dropdown-container']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-dropdown',[['color','paleyellow'],
          ['text','with headers']],(null as any),[[(null as any),'mouseenter'],[(null as any),
          'mouseleave']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('mouseenter' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,62).onHover()) !== false);
          ad = (pd_0 && ad);
        }
        if (('mouseleave' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,62).onLeave()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],hover:[3,'hover']},(null as any)),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),1,'admin-dropdown',[['color','brown'],
              ['text','disabled']],(null as any),[[(null as any),'mouseenter'],[(null as any),
              'mouseleave']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('mouseenter' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,64).onHover()) !== false);
              ad = (pd_0 && ad);
            }
            if (('mouseleave' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,64).onLeave()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],outlined:[3,'outlined'],hover:[4,'hover'],
              disabled:[5,'disabled']},(null as any)),(_l()(),i1.ɵeld(0,(null as any),
          1,4,'div',[['class','dropdown-container']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          1,'admin-dropdown',[['color','brown'],['text','basic']],(null as any),[[(null as any),
              'mouseenter'],[(null as any),'mouseleave']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('mouseenter' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,67).onHover()) !== false);
              ad = (pd_0 && ad);
            }
            if (('mouseleave' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,67).onLeave()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],hover:[3,'hover'],dropup:[4,'dropup']},
          (null as any)),(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-dropdown',
          [['color','brown'],['text','outlined']],(null as any),[[(null as any),'mouseenter'],
              [(null as any),'mouseleave']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('mouseenter' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,69).onHover()) !== false);
              ad = (pd_0 && ad);
            }
            if (('mouseleave' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,69).onLeave()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],outlined:[3,'outlined'],hover:[4,'hover'],
              dropup:[5,'dropup']},(null as any)),(_l()(),i1.ɵeld(0,(null as any),
          1,4,'div',[['class','dropdown-container']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          1,'admin-dropdown',[['color','paleyellow'],['text','with headers']],(null as any),
          [[(null as any),'mouseenter'],[(null as any),'mouseleave']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('mouseenter' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,72).onHover()) !== false);
              ad = (pd_0 && ad);
            }
            if (('mouseleave' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,72).onLeave()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],hover:[3,'hover'],dropup:[4,'dropup']},
          (null as any)),(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-dropdown',
          [['color','brown'],['text','disabled']],(null as any),[[(null as any),'mouseenter'],
              [(null as any),'mouseleave']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('mouseenter' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,74).onHover()) !== false);
              ad = (pd_0 && ad);
            }
            if (('mouseleave' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,74).onLeave()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],outlined:[3,'outlined'],hover:[4,'hover'],
              dropup:[5,'dropup'],disabled:[6,'disabled']},(null as any))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_3:any = true;
    const currVal_4:any = 'rgb(85,201,166)';
    _ck(_v,1,0,currVal_3,currVal_4);
    const currVal_5:any = 'basic';
    const currVal_6:any = _co.options;
    const currVal_7:any = 'green';
    _ck(_v,7,0,currVal_5,currVal_6,currVal_7);
    const currVal_8:any = 'outlined';
    const currVal_9:any = _co.options;
    const currVal_10:any = 'green';
    const currVal_11:any = true;
    _ck(_v,9,0,currVal_8,currVal_9,currVal_10,currVal_11);
    const currVal_12:any = 'with headers';
    const currVal_13:any = _co.optionsWithHeaders;
    const currVal_14:any = 'blue';
    _ck(_v,12,0,currVal_12,currVal_13,currVal_14);
    const currVal_15:any = 'disabled';
    const currVal_16:any = _co.options;
    const currVal_17:any = 'darkblue';
    const currVal_18:any = true;
    const currVal_19:any = true;
    _ck(_v,14,0,currVal_15,currVal_16,currVal_17,currVal_18,currVal_19);
    const currVal_20:any = 'basic';
    const currVal_21:any = _co.options;
    const currVal_22:any = 'green';
    const currVal_23:any = true;
    _ck(_v,17,0,currVal_20,currVal_21,currVal_22,currVal_23);
    const currVal_24:any = 'outlined';
    const currVal_25:any = _co.options;
    const currVal_26:any = 'green';
    const currVal_27:any = true;
    const currVal_28:any = true;
    _ck(_v,19,0,currVal_24,currVal_25,currVal_26,currVal_27,currVal_28);
    const currVal_29:any = 'with headers';
    const currVal_30:any = _co.optionsWithHeaders;
    const currVal_31:any = 'blue';
    const currVal_32:any = true;
    _ck(_v,22,0,currVal_29,currVal_30,currVal_31,currVal_32);
    const currVal_33:any = 'disabled';
    const currVal_34:any = _co.options;
    const currVal_35:any = 'darkblue';
    const currVal_36:any = true;
    const currVal_37:any = true;
    const currVal_38:any = true;
    _ck(_v,24,0,currVal_33,currVal_34,currVal_35,currVal_36,currVal_37,currVal_38);
    const currVal_42:any = true;
    const currVal_43:any = false;
    const currVal_44:any = 'rgb(85,201,166)';
    _ck(_v,26,0,currVal_42,currVal_43,currVal_44);
    const currVal_45:any = 'basic';
    const currVal_46:any = _co.options;
    const currVal_47:any = 'darkblue';
    const currVal_48:any = true;
    _ck(_v,32,0,currVal_45,currVal_46,currVal_47,currVal_48);
    const currVal_49:any = 'outlined';
    const currVal_50:any = _co.options;
    const currVal_51:any = 'darkblue';
    const currVal_52:any = true;
    _ck(_v,34,0,currVal_49,currVal_50,currVal_51,currVal_52);
    const currVal_53:any = 'with headers';
    const currVal_54:any = _co.optionsWithHeaders;
    const currVal_55:any = 'darkblue';
    const currVal_56:any = true;
    _ck(_v,37,0,currVal_53,currVal_54,currVal_55,currVal_56);
    const currVal_57:any = 'disabled';
    const currVal_58:any = _co.options;
    const currVal_59:any = 'darkblue';
    const currVal_60:any = true;
    const currVal_61:any = true;
    _ck(_v,39,0,currVal_57,currVal_58,currVal_59,currVal_60,currVal_61);
    const currVal_62:any = 'basic';
    const currVal_63:any = _co.options;
    const currVal_64:any = 'darkblue';
    const currVal_65:any = true;
    const currVal_66:any = true;
    _ck(_v,42,0,currVal_62,currVal_63,currVal_64,currVal_65,currVal_66);
    const currVal_67:any = 'outlined';
    const currVal_68:any = _co.options;
    const currVal_69:any = 'darkblue';
    const currVal_70:any = true;
    const currVal_71:any = true;
    _ck(_v,44,0,currVal_67,currVal_68,currVal_69,currVal_70,currVal_71);
    const currVal_72:any = 'with headers';
    const currVal_73:any = _co.optionsWithHeaders;
    const currVal_74:any = 'darkblue';
    const currVal_75:any = true;
    const currVal_76:any = true;
    _ck(_v,47,0,currVal_72,currVal_73,currVal_74,currVal_75,currVal_76);
    const currVal_77:any = 'disabled';
    const currVal_78:any = _co.options;
    const currVal_79:any = 'darkblue';
    const currVal_80:any = true;
    const currVal_81:any = true;
    const currVal_82:any = true;
    _ck(_v,49,0,currVal_77,currVal_78,currVal_79,currVal_80,currVal_81,currVal_82);
    const currVal_86:any = true;
    const currVal_87:any = 'rgb(168,85,58)';
    _ck(_v,51,0,currVal_86,currVal_87);
    const currVal_88:any = 'basic';
    const currVal_89:any = _co.options;
    const currVal_90:any = 'brown';
    const currVal_91:any = true;
    _ck(_v,57,0,currVal_88,currVal_89,currVal_90,currVal_91);
    const currVal_92:any = 'outlined';
    const currVal_93:any = _co.options;
    const currVal_94:any = 'brown';
    const currVal_95:any = true;
    const currVal_96:any = true;
    _ck(_v,59,0,currVal_92,currVal_93,currVal_94,currVal_95,currVal_96);
    const currVal_97:any = 'with headers';
    const currVal_98:any = _co.optionsWithHeaders;
    const currVal_99:any = 'paleyellow';
    const currVal_100:any = true;
    _ck(_v,62,0,currVal_97,currVal_98,currVal_99,currVal_100);
    const currVal_101:any = 'disabled';
    const currVal_102:any = _co.options;
    const currVal_103:any = 'brown';
    const currVal_104:any = true;
    const currVal_105:any = true;
    const currVal_106:any = true;
    _ck(_v,64,0,currVal_101,currVal_102,currVal_103,currVal_104,currVal_105,currVal_106);
    const currVal_107:any = 'basic';
    const currVal_108:any = _co.options;
    const currVal_109:any = 'brown';
    const currVal_110:any = true;
    const currVal_111:any = true;
    _ck(_v,67,0,currVal_107,currVal_108,currVal_109,currVal_110,currVal_111);
    const currVal_112:any = 'outlined';
    const currVal_113:any = _co.options;
    const currVal_114:any = 'brown';
    const currVal_115:any = true;
    const currVal_116:any = true;
    const currVal_117:any = true;
    _ck(_v,69,0,currVal_112,currVal_113,currVal_114,currVal_115,currVal_116,currVal_117);
    const currVal_118:any = 'with headers';
    const currVal_119:any = _co.optionsWithHeaders;
    const currVal_120:any = 'paleyellow';
    const currVal_121:any = true;
    const currVal_122:any = true;
    _ck(_v,72,0,currVal_118,currVal_119,currVal_120,currVal_121,currVal_122);
    const currVal_123:any = 'disabled';
    const currVal_124:any = _co.options;
    const currVal_125:any = 'brown';
    const currVal_126:any = true;
    const currVal_127:any = true;
    const currVal_128:any = true;
    const currVal_129:any = true;
    _ck(_v,74,0,currVal_123,currVal_124,currVal_125,currVal_126,currVal_127,currVal_128,
        currVal_129);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1).tabbed;
    const currVal_1:any = i1.ɵnov(_v,1).isMinimized;
    const currVal_2:any = i1.ɵnov(_v,1).isClosed;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
    const currVal_39:any = i1.ɵnov(_v,26).tabbed;
    const currVal_40:any = i1.ɵnov(_v,26).isMinimized;
    const currVal_41:any = i1.ɵnov(_v,26).isClosed;
    _ck(_v,25,0,currVal_39,currVal_40,currVal_41);
    const currVal_83:any = i1.ɵnov(_v,51).tabbed;
    const currVal_84:any = i1.ɵnov(_v,51).isMinimized;
    const currVal_85:any = i1.ɵnov(_v,51).isClosed;
    _ck(_v,50,0,currVal_83,currVal_84,currVal_85);
  });
}
function View_DropdownDemoComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),24,'admin-panel',
      [['class','panel--split'],['headerColor','rgb(234,120,130)']],[[2,'tabbed',(null as any)],
          [2,'minimized',(null as any)],[2,'closed',(null as any)]],(null as any),
      (null as any),i2.View_PanelComponent_0,i2.RenderType_PanelComponent)),i1.ɵdid(4767744,
      (null as any),0,i3.PanelComponent,([] as any[]),{showHeader:[0,'showHeader'],
          headerColor:[1,'headerColor']},(null as any)),(_l()(),i1.ɵeld(0,(null as any),
      0,2,'header',([] as any[]),(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'h3',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted((null as any),['Split button dropdowns and dropups'])),(_l()(),i1.ɵeld(0,
      (null as any),1,4,'div',[['class','dropdown-container']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),1,'admin-dropdown',[['color','red'],['text','basic']],(null as any),
      [[(null as any),'mouseenter'],[(null as any),'mouseleave']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('mouseenter' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,7).onHover()) !== false);
          ad = (pd_0 && ad);
        }
        if (('mouseleave' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,7).onLeave()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
      (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
          'options'],color:[2,'color'],split:[3,'split']},(null as any)),(_l()(),i1.ɵeld(0,
      (null as any),(null as any),1,'admin-dropdown',[['color','red'],['text','outlined']],
      (null as any),[[(null as any),'mouseenter'],[(null as any),'mouseleave']],(_v,
          en,$event) => {
        var ad:boolean = true;
        if (('mouseenter' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,9).onHover()) !== false);
          ad = (pd_0 && ad);
        }
        if (('mouseleave' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,9).onLeave()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
      (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
          'options'],color:[2,'color'],outlined:[3,'outlined'],split:[4,'split']},
      (null as any)),(_l()(),i1.ɵeld(0,(null as any),1,4,'div',[['class','dropdown-container']],
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵeld(0,(null as any),(null as any),1,'admin-dropdown',[['color','blue'],['text',
          'with headers']],(null as any),[[(null as any),'mouseenter'],[(null as any),
          'mouseleave']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('mouseenter' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,12).onHover()) !== false);
          ad = (pd_0 && ad);
        }
        if (('mouseleave' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,12).onLeave()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
      (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
          'options'],color:[2,'color'],split:[3,'split']},(null as any)),(_l()(),i1.ɵeld(0,
      (null as any),(null as any),1,'admin-dropdown',[['color','darkblue'],['text',
          'disabled']],(null as any),[[(null as any),'mouseenter'],[(null as any),
          'mouseleave']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('mouseenter' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,14).onHover()) !== false);
          ad = (pd_0 && ad);
        }
        if (('mouseleave' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,14).onLeave()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
      (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
          'options'],color:[2,'color'],outlined:[3,'outlined'],split:[4,'split'],disabled:[5,
          'disabled']},(null as any)),(_l()(),i1.ɵeld(0,(null as any),1,4,'div',[['class',
      'dropdown-container']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-dropdown',
      [['color','red'],['text','basic']],(null as any),[[(null as any),'mouseenter'],
          [(null as any),'mouseleave']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('mouseenter' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,17).onHover()) !== false);
          ad = (pd_0 && ad);
        }
        if (('mouseleave' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,17).onLeave()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
      (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
          'options'],color:[2,'color'],split:[3,'split'],dropup:[4,'dropup']},(null as any)),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-dropdown',[['color','red'],
          ['text','outlined']],(null as any),[[(null as any),'mouseenter'],[(null as any),
          'mouseleave']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('mouseenter' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,19).onHover()) !== false);
          ad = (pd_0 && ad);
        }
        if (('mouseleave' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,19).onLeave()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],outlined:[3,'outlined'],split:[4,'split'],
              dropup:[5,'dropup']},(null as any)),(_l()(),i1.ɵeld(0,(null as any),
          1,4,'div',[['class','dropdown-container']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          1,'admin-dropdown',[['color','blue'],['text','with headers']],(null as any),
          [[(null as any),'mouseenter'],[(null as any),'mouseleave']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('mouseenter' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,22).onHover()) !== false);
              ad = (pd_0 && ad);
            }
            if (('mouseleave' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,22).onLeave()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],split:[3,'split'],dropup:[4,'dropup']},
          (null as any)),(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-dropdown',
          [['color','darkblue'],['text','disabled']],(null as any),[[(null as any),
              'mouseenter'],[(null as any),'mouseleave']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('mouseenter' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,24).onHover()) !== false);
              ad = (pd_0 && ad);
            }
            if (('mouseleave' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,24).onLeave()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],outlined:[3,'outlined'],split:[4,'split'],
              dropup:[5,'dropup'],disabled:[6,'disabled']},(null as any)),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),24,'admin-panel',[['class','panel--split-inverse'],
              ['headerColor','rgb(234,120,130)']],[[2,'tabbed',(null as any)],[2,'minimized',
              (null as any)],[2,'closed',(null as any)]],(null as any),(null as any),
              i2.View_PanelComponent_0,i2.RenderType_PanelComponent)),i1.ɵdid(4767744,
          (null as any),0,i3.PanelComponent,([] as any[]),{showHeader:[0,'showHeader'],
              showBody:[1,'showBody'],headerColor:[2,'headerColor']},(null as any)),
      (_l()(),i1.ɵeld(0,(null as any),0,22,'header',([] as any[]),(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),1,'h3',([] as any[]),(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['Split button dropdowns and dropups (inverse)'])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),4,'div',[['class','dropdown-container']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-dropdown',[['color','darkgreen'],
          ['text','basic']],(null as any),[[(null as any),'mouseenter'],[(null as any),
          'mouseleave']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('mouseenter' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,32).onHover()) !== false);
          ad = (pd_0 && ad);
        }
        if (('mouseleave' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,32).onLeave()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],inverse:[3,'inverse'],split:[4,'split']},
          (null as any)),(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-dropdown',
          [['color','darkgreen'],['text','outlined']],(null as any),[[(null as any),
              'mouseenter'],[(null as any),'mouseleave']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('mouseenter' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,34).onHover()) !== false);
              ad = (pd_0 && ad);
            }
            if (('mouseleave' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,34).onLeave()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],inverse:[3,'inverse'],split:[4,'split']},
          (null as any)),(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'div',[['class',
          'dropdown-container']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-dropdown',
          [['color','darkgreen'],['text','with headers']],(null as any),[[(null as any),
              'mouseenter'],[(null as any),'mouseleave']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('mouseenter' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,37).onHover()) !== false);
              ad = (pd_0 && ad);
            }
            if (('mouseleave' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,37).onLeave()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],inverse:[3,'inverse'],split:[4,'split']},
          (null as any)),(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-dropdown',
          [['color','darkgreen'],['text','disabled']],(null as any),[[(null as any),
              'mouseenter'],[(null as any),'mouseleave']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('mouseenter' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,39).onHover()) !== false);
              ad = (pd_0 && ad);
            }
            if (('mouseleave' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,39).onLeave()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],inverse:[3,'inverse'],split:[4,'split'],
              disabled:[5,'disabled']},(null as any)),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),4,'div',[['class','dropdown-container']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),1,'admin-dropdown',[['color','darkgreen'],['text','basic']],
          (null as any),[[(null as any),'mouseenter'],[(null as any),'mouseleave']],
          (_v,en,$event) => {
            var ad:boolean = true;
            if (('mouseenter' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,42).onHover()) !== false);
              ad = (pd_0 && ad);
            }
            if (('mouseleave' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,42).onLeave()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],inverse:[3,'inverse'],split:[4,'split'],
              dropup:[5,'dropup']},(null as any)),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),1,'admin-dropdown',[['color','darkgreen'],['text','outlined']],
          (null as any),[[(null as any),'mouseenter'],[(null as any),'mouseleave']],
          (_v,en,$event) => {
            var ad:boolean = true;
            if (('mouseenter' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,44).onHover()) !== false);
              ad = (pd_0 && ad);
            }
            if (('mouseleave' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,44).onLeave()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],inverse:[3,'inverse'],split:[4,'split'],
              dropup:[5,'dropup']},(null as any)),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),4,'div',[['class','dropdown-container']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),1,'admin-dropdown',[['color','darkgreen'],['text','with headers']],
          (null as any),[[(null as any),'mouseenter'],[(null as any),'mouseleave']],
          (_v,en,$event) => {
            var ad:boolean = true;
            if (('mouseenter' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,47).onHover()) !== false);
              ad = (pd_0 && ad);
            }
            if (('mouseleave' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,47).onLeave()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],inverse:[3,'inverse'],split:[4,'split'],
              dropup:[5,'dropup']},(null as any)),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),1,'admin-dropdown',[['color','darkgreen'],['text','disabled']],
          (null as any),[[(null as any),'mouseenter'],[(null as any),'mouseleave']],
          (_v,en,$event) => {
            var ad:boolean = true;
            if (('mouseenter' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,49).onHover()) !== false);
              ad = (pd_0 && ad);
            }
            if (('mouseleave' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,49).onLeave()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],inverse:[3,'inverse'],split:[4,'split'],
              dropup:[5,'dropup'],disabled:[6,'disabled']},(null as any)),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),24,'admin-panel',[['class','panel--split-hover'],
              ['headerColor','rgb(121,176,236)']],[[2,'tabbed',(null as any)],[2,'minimized',
              (null as any)],[2,'closed',(null as any)]],(null as any),(null as any),
              i2.View_PanelComponent_0,i2.RenderType_PanelComponent)),i1.ɵdid(4767744,
          (null as any),0,i3.PanelComponent,([] as any[]),{showHeader:[0,'showHeader'],
              headerColor:[1,'headerColor']},(null as any)),(_l()(),i1.ɵeld(0,(null as any),
          0,2,'header',([] as any[]),(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'h3',([] as any[]),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['Split button dropdowns and dropups (hover buttons)'])),
      (_l()(),i1.ɵeld(0,(null as any),1,4,'div',[['class','dropdown-container']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),1,'admin-dropdown',[['color','blue'],['text',
              'basic']],(null as any),[[(null as any),'mouseenter'],[(null as any),
              'mouseleave']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('mouseenter' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,57).onHover()) !== false);
              ad = (pd_0 && ad);
            }
            if (('mouseleave' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,57).onLeave()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],hover:[3,'hover'],split:[4,'split']},(null as any)),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-dropdown',[['color','blue'],
          ['text','outlined']],(null as any),[[(null as any),'mouseenter'],[(null as any),
          'mouseleave']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('mouseenter' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,59).onHover()) !== false);
          ad = (pd_0 && ad);
        }
        if (('mouseleave' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,59).onLeave()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],outlined:[3,'outlined'],hover:[4,'hover'],
              split:[5,'split']},(null as any)),(_l()(),i1.ɵeld(0,(null as any),1,
          4,'div',[['class','dropdown-container']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          1,'admin-dropdown',[['color','paleyellow'],['text','with headers']],(null as any),
          [[(null as any),'mouseenter'],[(null as any),'mouseleave']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('mouseenter' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,62).onHover()) !== false);
              ad = (pd_0 && ad);
            }
            if (('mouseleave' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,62).onLeave()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],hover:[3,'hover'],split:[4,'split']},(null as any)),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-dropdown',[['color','brown'],
          ['text','disabled']],(null as any),[[(null as any),'mouseenter'],[(null as any),
          'mouseleave']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('mouseenter' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,64).onHover()) !== false);
          ad = (pd_0 && ad);
        }
        if (('mouseleave' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,64).onLeave()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],outlined:[3,'outlined'],hover:[4,'hover'],
              split:[5,'split'],disabled:[6,'disabled']},(null as any)),(_l()(),i1.ɵeld(0,
          (null as any),1,4,'div',[['class','dropdown-container']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),1,'admin-dropdown',[['color','blue'],['text','basic']],(null as any),
          [[(null as any),'mouseenter'],[(null as any),'mouseleave']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('mouseenter' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,67).onHover()) !== false);
              ad = (pd_0 && ad);
            }
            if (('mouseleave' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,67).onLeave()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],hover:[3,'hover'],split:[4,'split'],dropup:[5,
              'dropup']},(null as any)),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          1,'admin-dropdown',[['color','blue'],['text','outlined']],(null as any),
          [[(null as any),'mouseenter'],[(null as any),'mouseleave']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('mouseenter' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,69).onHover()) !== false);
              ad = (pd_0 && ad);
            }
            if (('mouseleave' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,69).onLeave()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],outlined:[3,'outlined'],hover:[4,'hover'],
              split:[5,'split'],dropup:[6,'dropup']},(null as any)),(_l()(),i1.ɵeld(0,
          (null as any),1,4,'div',[['class','dropdown-container']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),1,'admin-dropdown',[['color','paleyellow'],['text','with headers']],
          (null as any),[[(null as any),'mouseenter'],[(null as any),'mouseleave']],
          (_v,en,$event) => {
            var ad:boolean = true;
            if (('mouseenter' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,72).onHover()) !== false);
              ad = (pd_0 && ad);
            }
            if (('mouseleave' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,72).onLeave()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],hover:[3,'hover'],split:[4,'split'],dropup:[5,
              'dropup']},(null as any)),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          1,'admin-dropdown',[['color','brown'],['text','disabled']],(null as any),
          [[(null as any),'mouseenter'],[(null as any),'mouseleave']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('mouseenter' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,74).onHover()) !== false);
              ad = (pd_0 && ad);
            }
            if (('mouseleave' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,74).onLeave()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i4.View_DropdownComponent_0,i4.RenderType_DropdownComponent)),i1.ɵdid(573440,
          (null as any),0,i5.DropdownComponent,[i1.ElementRef],{text:[0,'text'],options:[1,
              'options'],color:[2,'color'],outlined:[3,'outlined'],hover:[4,'hover'],
              split:[5,'split'],dropup:[6,'dropup'],disabled:[7,'disabled']},(null as any))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_3:any = true;
        const currVal_4:any = 'rgb(234,120,130)';
        _ck(_v,1,0,currVal_3,currVal_4);
        const currVal_5:any = 'basic';
        const currVal_6:any = _co.options;
        const currVal_7:any = 'red';
        const currVal_8:any = true;
        _ck(_v,7,0,currVal_5,currVal_6,currVal_7,currVal_8);
        const currVal_9:any = 'outlined';
        const currVal_10:any = _co.options;
        const currVal_11:any = 'red';
        const currVal_12:any = true;
        const currVal_13:any = true;
        _ck(_v,9,0,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13);
        const currVal_14:any = 'with headers';
        const currVal_15:any = _co.optionsWithHeaders;
        const currVal_16:any = 'blue';
        const currVal_17:any = true;
        _ck(_v,12,0,currVal_14,currVal_15,currVal_16,currVal_17);
        const currVal_18:any = 'disabled';
        const currVal_19:any = _co.options;
        const currVal_20:any = 'darkblue';
        const currVal_21:any = true;
        const currVal_22:any = true;
        const currVal_23:any = true;
        _ck(_v,14,0,currVal_18,currVal_19,currVal_20,currVal_21,currVal_22,currVal_23);
        const currVal_24:any = 'basic';
        const currVal_25:any = _co.options;
        const currVal_26:any = 'red';
        const currVal_27:any = true;
        const currVal_28:any = true;
        _ck(_v,17,0,currVal_24,currVal_25,currVal_26,currVal_27,currVal_28);
        const currVal_29:any = 'outlined';
        const currVal_30:any = _co.options;
        const currVal_31:any = 'red';
        const currVal_32:any = true;
        const currVal_33:any = true;
        const currVal_34:any = true;
        _ck(_v,19,0,currVal_29,currVal_30,currVal_31,currVal_32,currVal_33,currVal_34);
        const currVal_35:any = 'with headers';
        const currVal_36:any = _co.optionsWithHeaders;
        const currVal_37:any = 'blue';
        const currVal_38:any = true;
        const currVal_39:any = true;
        _ck(_v,22,0,currVal_35,currVal_36,currVal_37,currVal_38,currVal_39);
        const currVal_40:any = 'disabled';
        const currVal_41:any = _co.options;
        const currVal_42:any = 'darkblue';
        const currVal_43:any = true;
        const currVal_44:any = true;
        const currVal_45:any = true;
        const currVal_46:any = true;
        _ck(_v,24,0,currVal_40,currVal_41,currVal_42,currVal_43,currVal_44,currVal_45,
            currVal_46);
        const currVal_50:any = true;
        const currVal_51:any = false;
        const currVal_52:any = 'rgb(234,120,130)';
        _ck(_v,26,0,currVal_50,currVal_51,currVal_52);
        const currVal_53:any = 'basic';
        const currVal_54:any = _co.options;
        const currVal_55:any = 'darkgreen';
        const currVal_56:any = true;
        const currVal_57:any = true;
        _ck(_v,32,0,currVal_53,currVal_54,currVal_55,currVal_56,currVal_57);
        const currVal_58:any = 'outlined';
        const currVal_59:any = _co.options;
        const currVal_60:any = 'darkgreen';
        const currVal_61:any = true;
        const currVal_62:any = true;
        _ck(_v,34,0,currVal_58,currVal_59,currVal_60,currVal_61,currVal_62);
        const currVal_63:any = 'with headers';
        const currVal_64:any = _co.optionsWithHeaders;
        const currVal_65:any = 'darkgreen';
        const currVal_66:any = true;
        const currVal_67:any = true;
        _ck(_v,37,0,currVal_63,currVal_64,currVal_65,currVal_66,currVal_67);
        const currVal_68:any = 'disabled';
        const currVal_69:any = _co.options;
        const currVal_70:any = 'darkgreen';
        const currVal_71:any = true;
        const currVal_72:any = true;
        const currVal_73:any = true;
        _ck(_v,39,0,currVal_68,currVal_69,currVal_70,currVal_71,currVal_72,currVal_73);
        const currVal_74:any = 'basic';
        const currVal_75:any = _co.options;
        const currVal_76:any = 'darkgreen';
        const currVal_77:any = true;
        const currVal_78:any = true;
        const currVal_79:any = true;
        _ck(_v,42,0,currVal_74,currVal_75,currVal_76,currVal_77,currVal_78,currVal_79);
        const currVal_80:any = 'outlined';
        const currVal_81:any = _co.options;
        const currVal_82:any = 'darkgreen';
        const currVal_83:any = true;
        const currVal_84:any = true;
        const currVal_85:any = true;
        _ck(_v,44,0,currVal_80,currVal_81,currVal_82,currVal_83,currVal_84,currVal_85);
        const currVal_86:any = 'with headers';
        const currVal_87:any = _co.optionsWithHeaders;
        const currVal_88:any = 'darkgreen';
        const currVal_89:any = true;
        const currVal_90:any = true;
        const currVal_91:any = true;
        _ck(_v,47,0,currVal_86,currVal_87,currVal_88,currVal_89,currVal_90,currVal_91);
        const currVal_92:any = 'disabled';
        const currVal_93:any = _co.options;
        const currVal_94:any = 'darkgreen';
        const currVal_95:any = true;
        const currVal_96:any = true;
        const currVal_97:any = true;
        const currVal_98:any = true;
        _ck(_v,49,0,currVal_92,currVal_93,currVal_94,currVal_95,currVal_96,currVal_97,
            currVal_98);
        const currVal_102:any = true;
        const currVal_103:any = 'rgb(121,176,236)';
        _ck(_v,51,0,currVal_102,currVal_103);
        const currVal_104:any = 'basic';
        const currVal_105:any = _co.options;
        const currVal_106:any = 'blue';
        const currVal_107:any = true;
        const currVal_108:any = true;
        _ck(_v,57,0,currVal_104,currVal_105,currVal_106,currVal_107,currVal_108);
        const currVal_109:any = 'outlined';
        const currVal_110:any = _co.options;
        const currVal_111:any = 'blue';
        const currVal_112:any = true;
        const currVal_113:any = true;
        const currVal_114:any = true;
        _ck(_v,59,0,currVal_109,currVal_110,currVal_111,currVal_112,currVal_113,currVal_114);
        const currVal_115:any = 'with headers';
        const currVal_116:any = _co.optionsWithHeaders;
        const currVal_117:any = 'paleyellow';
        const currVal_118:any = true;
        const currVal_119:any = true;
        _ck(_v,62,0,currVal_115,currVal_116,currVal_117,currVal_118,currVal_119);
        const currVal_120:any = 'disabled';
        const currVal_121:any = _co.options;
        const currVal_122:any = 'brown';
        const currVal_123:any = true;
        const currVal_124:any = true;
        const currVal_125:any = true;
        const currVal_126:any = true;
        _ck(_v,64,0,currVal_120,currVal_121,currVal_122,currVal_123,currVal_124,currVal_125,
            currVal_126);
        const currVal_127:any = 'basic';
        const currVal_128:any = _co.options;
        const currVal_129:any = 'blue';
        const currVal_130:any = true;
        const currVal_131:any = true;
        const currVal_132:any = true;
        _ck(_v,67,0,currVal_127,currVal_128,currVal_129,currVal_130,currVal_131,currVal_132);
        const currVal_133:any = 'outlined';
        const currVal_134:any = _co.options;
        const currVal_135:any = 'blue';
        const currVal_136:any = true;
        const currVal_137:any = true;
        const currVal_138:any = true;
        const currVal_139:any = true;
        _ck(_v,69,0,currVal_133,currVal_134,currVal_135,currVal_136,currVal_137,currVal_138,
            currVal_139);
        const currVal_140:any = 'with headers';
        const currVal_141:any = _co.optionsWithHeaders;
        const currVal_142:any = 'paleyellow';
        const currVal_143:any = true;
        const currVal_144:any = true;
        const currVal_145:any = true;
        _ck(_v,72,0,currVal_140,currVal_141,currVal_142,currVal_143,currVal_144,currVal_145);
        const currVal_146:any = 'disabled';
        const currVal_147:any = _co.options;
        const currVal_148:any = 'brown';
        const currVal_149:any = true;
        const currVal_150:any = true;
        const currVal_151:any = true;
        const currVal_152:any = true;
        const currVal_153:any = true;
        _ck(_v,74,0,currVal_146,currVal_147,currVal_148,currVal_149,currVal_150,currVal_151,
            currVal_152,currVal_153);
      },(_ck,_v) => {
        const currVal_0:any = i1.ɵnov(_v,1).tabbed;
        const currVal_1:any = i1.ɵnov(_v,1).isMinimized;
        const currVal_2:any = i1.ɵnov(_v,1).isClosed;
        _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
        const currVal_47:any = i1.ɵnov(_v,26).tabbed;
        const currVal_48:any = i1.ɵnov(_v,26).isMinimized;
        const currVal_49:any = i1.ɵnov(_v,26).isClosed;
        _ck(_v,25,0,currVal_47,currVal_48,currVal_49);
        const currVal_99:any = i1.ɵnov(_v,51).tabbed;
        const currVal_100:any = i1.ɵnov(_v,51).isMinimized;
        const currVal_101:any = i1.ɵnov(_v,51).isClosed;
        _ck(_v,50,0,currVal_99,currVal_100,currVal_101);
      });
}
export function View_DropdownDemoComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),5,'admin-grid',([] as any[]),
      (null as any),(null as any),(null as any),i6.View_GridComponent_0,i6.RenderType_GridComponent)),
      i1.ɵdid(49152,(null as any),1,i7.GridComponent,([] as any[]),{cols:[0,'cols']},
          (null as any)),i1.ɵqud(603979776,1,{templates:1}),i1.ɵpad(2),(_l()(),i1.ɵand(0,
          [[1,2]],(null as any),0,(null as any),View_DropdownDemoComponent_1)),(_l()(),
          i1.ɵand(0,[[1,2]],(null as any),0,(null as any),View_DropdownDemoComponent_2))],
      (_ck,_v) => {
        const currVal_0:any = _ck(_v,3,0,6,6);
        _ck(_v,1,0,currVal_0);
      },(null as any));
}
export function View_DropdownDemoComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'ng-component',
      ([] as any[]),(null as any),(null as any),(null as any),View_DropdownDemoComponent_0,
      RenderType_DropdownDemoComponent)),i1.ɵdid(49152,(null as any),0,i8.DropdownDemoComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const DropdownDemoComponentNgFactory:i1.ComponentFactory<i8.DropdownDemoComponent> = i1.ɵccf('ng-component',
    i8.DropdownDemoComponent,View_DropdownDemoComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./$$_gendir/src/app/ui-element/dropdown/dropdown-demo.component.ngfactory.ts